























































































































































































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import rubric from "@/components/rubric.vue";
import guestTopBar from "@/components/guestTopBar.vue";
import player from "@/components/Player.vue";
import transcript from "@/components/users/userTranscript.vue";
import feedbackEditor from "@/components/editor/FeedbackEditor.vue";
import feedbackVideo from "@/components/FeedbackVideo.vue";
import consts from "../../consts";
import { findUser, parseAuthToken, getPropertyByKeys } from "../../utils";
// import { } from "../../types.ts";
import axios from "axios";
import moment from "moment";
import amplitude from "amplitude-js";
import { User, UserStat, Rubric, TeamActivity } from "../../types";
import { Getter } from "vuex-class";

@Component({
  components: {
    guestTopBar,
    player,
    transcript,
    feedbackEditor,
    feedbackVideo,
    rubric
  },
  filters: {
    moment(date: string) {
      return moment(date).format("l | h:mma");
    }
  }
})
export default class Feedback extends Vue {
  @Getter private JWT!: string;
  @Getter private currentTeam!: any;
  @Getter private currentTeamUsers!: User[];

  @Prop() private teamID!: string;
  @Prop() private userID!: string;
  @Prop() private sessionID!: string;

  @Prop() private isValidRoute!: (teamID: any, userID: any) => boolean;

  private currentSessionID: string | null = null;
  private currentSessionIndex: number | null = null;
  private sessionsData: any[] = [];
  private sessionData: any = {};
  private feedbackFormVisible: boolean = false;
  private isEditing: boolean = false;
  private editLoading: boolean = false;
  private viewOnly: boolean = false;
  private shareOnly: boolean = false;
  private feedbackSending: boolean = false;
  private feedbackSent: boolean = false;
  private localJWT: string = "";
  private localUID: string = "";
  private localSessionID: string = "";
  private startIndex: number = -1;
  private endIndex: number = -1;
  private currComment: number = -1;
  private $amplitude: any;
  private showFeedback: boolean = true;
  private findUser = findUser;

  private error: boolean = false; // API error
  private errorMsg: string = "Something went wrong.";

  private created() {
    this.viewOnly =
      this.$route.name === "feedback" ||
      this.$route.name === "feedbackSession" ||
      this.$route.name === "shareSession";
    this.shareOnly = this.$route.name === "shareSession";

    let amplitudeUID = this.userID;
    if (this.viewOnly) {
      if (this.shareOnly) {
        let sessionID = this.$route.params.sessionID;
        this.fetchSessionShared(sessionID);
      } else {
        this.localJWT = this.$cookies.get("ORAI_AUTH");
        if (this.localJWT) {
          this.localUID = parseAuthToken(this.localJWT).uid;
          amplitudeUID = this.localUID;
          this.fetchSessionsViewOnly(this.localUID);
        } else {
          // Not logged in, redirect to login
          this.$router.push({
            name: "login",
            params: { redirect: window.location.pathname }
          });
        }
      }
    } else {
      if (this.sessionID && this.currentTeamUsers) {
        this.fetchSession(this.sessionID, this.teamID, this.userID);
      }
    }

    // Setup amplitude
    amplitude.getInstance().init(consts.amplitudeKey, amplitudeUID, {
      saveEvents: true,
      includeUtm: true,
      includeReferrer: true
    });
    this.$amplitude = amplitude.getInstance();
  }

  private getCurrentlyEditing(i: number) {
    return i !== this.currComment || !this.isEditing;
  }

  private getMonogram(name: string) {
    let words = name.split(" ");
    let mono = "";
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < words.length; ++i) {
      mono += words[i].charAt(0).toUpperCase();
    }
    return mono;
  }

  private toggleTabs(show: boolean) {
    this.showFeedback = show;
  }

  private toggleFeedbackForm() {
    if (this.feedbackFormVisible || this.isEditing) {
      this.startIndex = -1;
      this.endIndex = -1;
      this.isEditing = false;
    }
    this.currComment = -1;
    this.feedbackFormVisible = !this.feedbackFormVisible;
  }

  private handleVideoFeedback(startIndex: number) {
    this.feedbackFormVisible = true;
    this.startIndex = startIndex;
    this.endIndex = startIndex;
  }

  private handleTextSelect(startIndex: number, endIndex: number) {
    console.log("feedback:"+startIndex+","+endIndex)
    this.startIndex = startIndex;
    this.endIndex = endIndex;
  }

  private handleCommentClick(comment: any, commentIndex: number) {
    if (commentIndex === this.currComment) {
      // Don't do anything for clicks on currently editing comment
      if (this.isEditing) {
        return;
      }
      this.currComment = -1;
      this.startIndex = -1;
      this.endIndex = -1;
    } else {
      this.feedbackFormVisible = false;
      this.isEditing = false;
      this.currComment = commentIndex;
      this.startIndex = comment.StartIndex !== null ? comment.StartIndex : -1;
      this.endIndex = comment.EndIndex !== null ? comment.EndIndex : -1;
    }
  }

  private handleEditClick(e: Event, comment: any, commentIndex: number) {
    e.stopPropagation();
    if (commentIndex !== this.currComment) {
      this.handleCommentClick(comment, commentIndex);
    }
    this.isEditing = true;
  }

  private addComment(comments: string, feedbackID: string) {
    if (comments && comments.length && this.currentSessionID) {
      this.editLoading = true;

      let data: any = {
        Comments: comments
      };

      if (this.startIndex >= 0 && this.endIndex >= 0) {
        data.StartIndex = this.startIndex;
        data.EndIndex = this.endIndex;
      }

      let method = "POST";
      let url =
        consts.serverURL +
        "session/" +
        this.currentSessionID +
        "/manager-feedback/";
      if (feedbackID) {
        method = "PUT";
        url =
          consts.serverURL +
          "session/" +
          this.currentSessionID +
          "/manager-feedback/" +
          feedbackID;
      }

      axios({
        method,
        url,
        headers: { Authentication: this.JWT },
        data
      })
        .then(resp => {
          console.log("ADDED COMMENT", resp.data);
          if (feedbackID) {
            this.$amplitude.logEvent("Manager_UserSession_EditFeedback");
          } else {
            this.$amplitude.logEvent("Manager_UserSession_SendFeedback");
          }
          this.fetchSessionOnly(this.currentSessionID as string, true);
        })
        .catch(reason => {
          console.log(reason, reason.response);
        });
    }
  }

  private deleteComment(feedbackID: string) {
    this.feedbackFormVisible = false;
    if (this.currentSessionID && feedbackID) {
      this.editLoading = true;
      axios({
        method: "DELETE",
        url:
          consts.serverURL +
          "session/" +
          this.currentSessionID +
          "/manager-feedback/" +
          feedbackID,
        headers: { Authentication: this.JWT }
      })
        .then(resp => {
          console.log("DELETED COMMENT", resp.data);
          this.fetchSessionOnly(this.currentSessionID as string, true);
        })
        .catch(reason => {
          console.log(reason, reason.response);
        });
    }
  }

  private changeSession(sessionID: string) {
    this.localSessionID = sessionID;
    this.fetchSessionOnly(sessionID);
    console.log("change session");
  }

  private sendFeedback() {
    if (this.currentSessionID && !this.feedbackSent && !this.feedbackSending) {
      this.feedbackSending = true;
      axios({
        method: "POST",
        url:
          consts.serverURL +
          "session/" +
          this.currentSessionID +
          "/manager-feedback/submit/",
        headers: { Authentication: this.JWT }
      })
        .then(resp => {
          this.feedbackSent = true;
          this.feedbackSending = false;
        })
        .catch(reason => {
          console.log(reason, reason.response);
        });
    }
  }

  private fetchSessionsViewOnly(userID: string) {
    console.log("fetch viww onlt");
    axios
      .get(consts.serverURL + "sessions/" + userID, {
        headers: { Authentication: this.localJWT }
      })
      .then(resp => {
        this.sessionsData = resp.data;
        console.log("SESSIONS", this.sessionsData);
        if (this.sessionsData.length) {
          let sessionID = this.$route.params.sessionID;
          if (!sessionID) {
            sessionID = this.sessionsData[0].SID;
          }
          this.changeSession(sessionID);
        }
      });
  }

  private fetchSession(sessionID: string, teamID: string, userID: string) {
    console.log(
      "VALID ROUTE",
      teamID,
      userID,
      this.isValidRoute(teamID, userID)
    );
    if (!this.isValidRoute(teamID, userID)) {
      this.$router.push({ path: "/" });
      return;
    }

    this.fetchSessionOnly(sessionID);
  }

  private fetchSessionOnly(sessionID: string, feedbackOnly: boolean = false) {
    // get session index
    if (this.sessionsData) {
      for (let i = 0; i < this.sessionsData.length; ++i) {
        if (this.sessionsData[i].SID === sessionID) {
          this.currentSessionIndex = i;
          break;
        }
      }
    }

    // Check if session data needs to be loaded
    if (this.currentSessionID !== null && this.currentSessionID !== sessionID) {
      // Trigger loading state when changing sessionData
      this.sessionData = {};
    }
    this.currentSessionID = sessionID;
    if (this.viewOnly) {
      this.$router.push({
        name: "feedbackSession",
        params: { sessionID }
      });
    }

    let jwt = this.viewOnly ? this.localJWT : this.JWT;

    axios
      .get(consts.serverURL + "session/" + sessionID + "/manager-feedback/", {
        headers: { Authentication: jwt }
      })
      .then(resp => {
        if (feedbackOnly) {
          this.sessionData.Feedback = resp.data.Feedback;
        } else {
          this.sessionData = resp.data;
        }

        this.feedbackFormVisible = false;
        this.editLoading = false;
        this.isEditing = false;
        this.currComment = -1;
        this.startIndex = -1;
        this.endIndex = -1;
        console.log("SESSION", this.sessionData);
      })
      .catch(reason => {
        console.log(reason, reason.response);
        this.error = true;
        this.errorMsg = reason.response.data.Error;
      });
  }

  private fetchSessionShared(sessionID: string) {
    axios
      .get(consts.serverURL + "session/public/" + sessionID + "?feedback=true")
      .then(resp => {
        console.log("SHARED SESSION", resp.data);
        let sessionData: any = { SessionDetails: {} };
        sessionData.SessionDetails.Title = resp.data.Title;
        sessionData.SessionDetails.AudioFileURL = resp.data.AudioFileURL;
        let fback = getPropertyByKeys(resp, ["data", "Feedback"]);
        if (fback) {
          let words = getPropertyByKeys(fback, ["transcriptData", "words"]);
          if (words) {
            sessionData.SessionDetails.Transcript = words;
          }
          let fillerTranscriptData = getPropertyByKeys(fback, [
            "transcriptData",
            "fillerTranscriptData"
          ]);
          if (fillerTranscriptData) {
            sessionData.SessionDetails.FillerWords = {
              Total: fillerTranscriptData.length,
              Locations: fillerTranscriptData
            };
          }
          let energy = getPropertyByKeys(fback, ["units", "energy", "score"]);
          if (energy) {
            sessionData.SessionDetails.Energy = energy;
          }
          let pace = getPropertyByKeys(fback, [
            "units",
            "pace",
            "graphData",
            "averagePace"
          ]);
          if (pace) {
            sessionData.SessionDetails.Pacing = pace;
          }
          let clarity = getPropertyByKeys(fback, ["units", "clarity", "score"]);
          if (clarity) {
            sessionData.SessionDetails.Clarity = clarity;
          }
        }
        this.sessionData = sessionData;
      })
      .catch(reason => {
        console.log(reason, reason.response);
        this.error = true;
        this.errorMsg = reason.response.data.Error;
      });
  }

  @Watch("currentTeamUsers")
  private onCurrentTeamUsersChanged(newVal: any, oldVal: any) {
    if (newVal && newVal !== oldVal && this.currentTeamUsers) {
      this.fetchSession(this.sessionID, this.teamID, this.userID);
    }
  }
}
